import classNames from 'classnames'
import React from 'react'
import {connect} from 'react-redux'

import {createStructuredSelector} from 'reselect'
import {isBuyPathActive} from '../../feature-flags'
import * as mobileMenu from '../../store/mobileMenu'
import * as user from '../../store/user'

import MobileAccountMenu from './MobileAccountMenu'
import MobileMenuClose from './MobileMenuClose'
import MobileMenuSignin from './MobileMenuSignin'
import MobileNav from './MobileNav'

type NavLinks = {
  title: string
  toSpa: boolean
  url: string
  target: string
}

interface MobileMenuProps {
  data: {
    accordions: {links: NavLinks[]; title: string}[]
    footerColumns: NavLinks[][]
  }
  userIsAuthenticated: boolean
  isOpen: boolean
}

const MobileMenu: React.FC<MobileMenuProps> = ({data, userIsAuthenticated, isOpen}) => {
  const classes = classNames('mobile-menu', {
    'is--open': isOpen,
  })
  let navWithoutBuyNew = data.accordions.filter(({title}: {title: string}) => title !== 'Buy New')
  navWithoutBuyNew = navWithoutBuyNew.map((item) => {
    if (item.title === 'Rental') {
      return {...item, title: 'Our Collection'}
    }
    return item
  })
  return (
    <aside className={classes}>
      <MobileNav
        accordions={isBuyPathActive ? data.accordions : navWithoutBuyNew}
        footerColumns={data.footerColumns}
      />
      {userIsAuthenticated ? <MobileAccountMenu /> : <MobileMenuSignin />}
      <MobileMenuClose />
    </aside>
  )
}

const mapStateToProps = createStructuredSelector({
  isOpen: mobileMenu.isOpen,
  userIsAuthenticated: user.isAuthenticated,
})

export default connect(mapStateToProps)(MobileMenu)
